import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import {getStorage} from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyCASsk1q1m-TSa-8Ahk5fFAhw4EmIVrzqc",
    authDomain: "document-management-449311.firebaseapp.com",
    projectId: "document-management-449311",
    storageBucket: "gs://document-management-449311.firebasestorage.app",
    messagingSenderId: "517325842627",
    appId: "1:517325842627:web:92064f7462dfb23b2e1a76",
    measurementId: "G-CP1MQSX6NV"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider("microsoft.com");
microsoftProvider.setCustomParameters({
  prompt: "consent",
  tenant: "328a179d-7b2a-4d40-87e6-6016c6457398",
})

const storage = getStorage(app);
export { auth, db, functions, googleProvider, microsoftProvider, storage };
